import React from "react"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { TabsBox } from "./tabs.styled"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

const Tabs = ({ tabs, setter, active }) => {
  const changeTab = (value, text) => {
    segmentEvent("Modal Tab Clicked", {
      module_location: "mid_fold",
      text: text,
    })
    setter(value)
  }

  const buildTab = (el) => {
    return (
      <button
        key={el.value}
        className={el.value === active ? `selected` : `unselected`}
        onClick={() => changeTab(el.value, el.label)}
      >
        <TextElementNova
          text={el.label}
          className={`${
            el.value === active
              ? "text-nova-base-black"
              : "text-nova-transparency-black-60"
          } CTA-20-Dia-Normal`}
        />
      </button>
    )
  }

  return <TabsBox className={``}>{tabs.map(buildTab)}</TabsBox>
}

export default Tabs
